'use client'

import { createContext, PropsWithChildren, useContext } from 'react'

import { View } from '@/shared/config'

type ViewState = {
  view: View | null
}

const ViewContext = createContext<ViewState | null>(null)

export const useView = () => {
  const context = useContext(ViewContext)

  if (!context) {
    throw new Error('useView must be used within a ResponsiveWrapper')
  }

  return context
}

type ProviderProps = {
  view: View | null
}

export const ResponsiveProvider = ({
  view,
  children,
}: PropsWithChildren<ProviderProps>) => {
  return (
    <ViewContext.Provider value={{ view }}>{children}</ViewContext.Provider>
  )
}
